import { render, staticRenderFns } from "./RegionsView.vue?vue&type=template&id=f275ab3e&scoped=true"
import script from "./RegionsView.vue?vue&type=script&lang=js"
export * from "./RegionsView.vue?vue&type=script&lang=js"
import style0 from "./RegionsView.vue?vue&type=style&index=0&id=f275ab3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f275ab3e",
  null
  
)

export default component.exports